import React, { useEffect, useState } from 'react'
import { Spin, Rate, Button, Modal } from 'antd';
import backBtn from "../../../assets/images/back-arrow.svg";
import deleteIcon from "../../../assets/images/deleteIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { getRequest, putRequest, deleteRequest } from '../../../api/http';
import { toast } from "react-toastify";
import userServiceApi from '../../../api/userServiceApi';
import "./deleteReviews.scss";
import { getAuthToken } from "../../../utils/helper";

export default function HubDeleteReviews() {
    const { state } = useLocation();
    const lastPage = state.page;
    const partnerId = sessionStorage.getItem("partnerId");
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const [deleteReviews, setDeleteReviews] = useState();

    const [selectedReviewId, setSelectedReviewId] = useState();
    const [denyModal, setDenyModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [approveModal, setApproveModal] = useState(false);


    const getHubDeleteReviews = async (partnerId) => {
        try {
            const res = await getRequest(userServiceApi.getDeleteReviews(partnerId, false))
            if (res) {
                // console.log("deleted", res)
                setDeleteReviews(res.data);
                setLoader(false);
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (partnerId) {
            getHubDeleteReviews(partnerId);
        }
    }, []);

    const formatDate = (reviewDate) => {
        const dateString = reviewDate;
        const date = new Date(dateString);
        const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
        return formattedDate
    }

    // 

    // DENY FLOW
    const denyRequest = async (reviewId) => {
        try {
            const authToken = getAuthToken();
            const headers = {
                Authorization: `Bearer ${authToken}`,
            };

            const response = await putRequest(
                userServiceApi.denyDeleteReview(reviewId)
            );
            if (response) {
                toast.success("Request denied successfully");
                getHubDeleteReviews();
            }
        } catch (error) {
            toast.error("Failed to deny request");
            // console.log(error);
        }
    };


    const handleDenyConfirm = () => {
        denyRequest(selectedReviewId);
        setDenyModal(false);
    };

    const showDenyModal = (reviewId) => {
        setSelectedReviewId(reviewId);
        setDenyModal(true);
    };

    // DELETE FLOW
    const rejectReview = async (reviewId) => {
        // toast.success("worked")
        try {
            const authToken = getAuthToken();
            const headers = {
                Authorization: `Bearer ${authToken}`,
            };

            const response = await deleteRequest(
                userServiceApi.approveDeleteReview(reviewId)
            );
            if (response) {
                toast.success("Review deleted successfully");
                getHubDeleteReviews();
            }
        } catch (error) {
            toast.error("failed to delete review!", error);
        }
    };

    const handleDeleteConfirm = () => {
        rejectReview(selectedReviewId);
        setDeleteModal(false);
    };

    const showDeleteModal = (reviewId) => {
        setSelectedReviewId(reviewId);
        setDeleteModal(true);
    };


    // APPROVE FLOW
    const approveReview = async (reviewId) => {
        // toast.success("worked")
        try {
            const authToken = getAuthToken();
            const headers = {
                Authorization: `Bearer ${authToken}`,
            };

            const response = await deleteRequest(
                userServiceApi.approveDeleteReview(reviewId)
            );
            if (response) {
                toast.success("Review approved successfully");
                getHubDeleteReviews(partnerId);
            }
        } catch (error) {
            toast.error("failed to approve review!", error);
        }
    };

    const handleApproveConfirm = () => {
        approveReview(selectedReviewId);
        setApproveModal(false);
    };

    const showApproveModal = (reviewId) => {
        setSelectedReviewId(reviewId);
        setApproveModal(true);
    };


    if (loader) {
        return (
            <div className="data-loader">
                <Spin className="spin" tip="Loading" size="large" />
            </div>
        );
    } else {
        return (
            <>
                <div className="tabContainer">
                    <div className="main-container" style={{ paddingTop: "5px" }}>
                        <div className="header-container">
                            <div className="backbtn-container">
                                <img src={backBtn} onClick={() => lastPage === "home" ? navigate('/partner-org') : navigate('/hub-members')} alt="" />
                                <p>Delete reviews - Hub members </p>
                            </div>
                        </div>
                        <div className="reviews-container">
                            {
                                deleteReviews && deleteReviews.length > 0 ? (
                                    deleteReviews.map((review) => (
                                        <>
                                            <div className="header">
                                                <div className='org-header'>
                                                    <p>{review.organizationName}</p>
                                                </div>
                                                <div className='micro-header'>
                                                    <p>{review.micrositeName}</p>
                                                </div>
                                                <div className='micro-header'>
                                                    <p>Rejection reason</p>
                                                </div>
                                            </div>
                                            <div className="review">
                                                <div className="review-intro">
                                                    <div className="microsite-name">{review.micrositeName}</div>
                                                </div>
                                                <div className="review-message">
                                                    <div className="rating">
                                                        <Rate className='ratings' allowHalf value={review.rating} disabled />
                                                        <div className="date">{formatDate(review.date)}</div>
                                                    </div>
                                                    <div className="message">{review.description}</div>
                                                </div>
                                                <div className="actions">
                                                    {review.partnerApprovalStatus === "PENDING" ? (
                                                        <>
                                                            <div className="approve-btn-container">
                                                                <Button className="approve-btn" onClick={() => showApproveModal(review.id)}>Approve</Button>
                                                            </div>
                                                            <div className="deny-btn-container">
                                                                <Button className="deny-btn" onClick={() => showDenyModal(review.id)}>Deny</Button>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <Button type="danger"
                                                            onClick={() => showDeleteModal(review.id)}
                                                        >
                                                            <img src={deleteIcon} alt="delete" />
                                                        </Button>
                                                    )}
                                                </div>
                                                <div className="review-message">
                                                    <div className="message">{review.rejectionReason}</div>
                                                </div>
                                            </div >
                                        </>
                                    ))
                                ) : (
                                    <div class="noDataSvailable">No data available</div>
                                )
                            }
                        </div>
                    </div>
                </div >
                <Modal
                    className='confirmation-modal'
                    footer={null}
                    open={denyModal}
                    onCancel={() => {
                        setDenyModal(false)
                    }}
                    destroyOnClose={true}
                    closable={false}
                >
                    <div className="message">
                        <p>Are you sure you want to deny the request to delete?</p>
                    </div>
                    <div className="modalBtns">
                        <Button label="No" className="cancel-btn"
                            onClick={() => {
                                setDenyModal(false);
                                setSelectedReviewId();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            label="Yes"
                            className="confirm-btn"
                            onClick={() => handleDenyConfirm()}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal>
                <Modal
                    className='confirmation-modal'
                    footer={null}
                    open={deleteModal}
                    onCancel={() => {
                        setDeleteModal(false)
                    }}
                    destroyOnClose={true}
                    closable={false}
                >
                    <div className="message">
                        <p>Are you sure you want to delete this review?</p>
                    </div>
                    <div className="modalBtns">
                        <Button label="No" className="cancel-btn"
                            onClick={() => {
                                setDeleteModal(false);
                                setSelectedReviewId();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            label="Yes"
                            className="confirm-btn"
                            onClick={() => handleDeleteConfirm()}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal>

                <Modal
                    className='confirmation-modal'
                    footer={null}
                    open={approveModal}
                    onCancel={() => {
                        setApproveModal(false)
                    }}
                    destroyOnClose={true}
                    closable={false}
                >
                    <div className="message">
                        <p>Are you sure you want to approve this review?</p>
                    </div>
                    <div className="modalBtns">
                        <Button label="No" className="cancel-btn"
                            onClick={() => {
                                setApproveModal(false);
                                setSelectedReviewId();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            label="Yes"
                            className="confirm-btn"
                            onClick={() => handleApproveConfirm()}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal>
            </>
        )
    }
}
